import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useCubit from "../../blocs/hooks";
import { ResumeBloc } from "../../blocs/resume/ResumeBloc";
import { ResumeState } from "../../blocs/resume/ResumeState";
import { kNavBarHeight } from "../../core/utils/constants";
import { LoadingData } from "../LoadingData";
import SomethingWentWrong from "../core/SomethingWentWrong";
import ResumeBodyV1 from "./ResumeBodyV1";
import ResumeBodyV2 from "./ResumeBodyV2";

const resumeBloc = new ResumeBloc()
export default function Resume() {
    const state = useCubit<ResumeState>(resumeBloc);
    const { id } = useParams();
    useEffect(() => {
        if (id !== undefined) {
            resumeBloc.getResumeById(id);
        }
    }, [id]);
    if (state.state === 'LOADING') {
        return <LoadingData />
    } else if (state.state === 'ERROR') {
        return <SomethingWentWrong />
    }
    const downloadResume = () => {
        const pdfUrl = state.data!.fileUrl;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "OussamaMaatallah.pdf"; // specify the filename
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return <div
        style={{
            paddingTop: kNavBarHeight + 20
        }}
    >
        {
            state.data?.markdown == null
                ? ResumeBodyV1(downloadResume, state)
                : ResumeBodyV2(downloadResume, state)
        }
    </div>
}

